import * as React from 'react';
import { Prompt } from 'react-router';
import { reduxForm } from 'redux-form';
import { compose, withHandlers, withProps, withState } from 'recompose';
import { get } from 'lodash';
import { Card } from 'material-ui/Card';

import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { OperationalWarehouseFormBasic } from '@modules/operationalWarehouse/operationalWarehouseFormBasic';

import { getOperationalWarehouse, putItem } from '@modules/operationalWarehouse/_operationalWarehouseActions';
import * as T from '@modules/operationalWarehouse/_operationalWarehouseTypes';
import { operationalWarehouseLabel, operationalWarehousePath } from './operationalWarehouseGrid';
import { Loader } from '@components/loader';
import { withNotifications } from '@components/hoc/withNotifications';
import { Tabs } from '@components/tabs';
import Histories from './operationalWarehouseFormHistories';

export const enhance = compose<T.OperationalWarehouseFormProps, T.Outter>(
  entityDetailEnhancer<T.OperationalWarehouseEnhancerProps<T.OperationalWarehouse>, T.OperationalWarehouse>({
    getEntity: getOperationalWarehouse,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: operationalWarehouseLabel, to: operationalWarehousePath },
    { label: get(entity, 'id') ? 'Upravit záznam' : 'Nový záznam' }
  ]),
  withNotifications({ putItem }),
  withState<{}, boolean, string, string>('loader', 'handleLoader', false),
  withState<{}, any, string, string>('activeTab', 'setActiveTab', 'item'),
  withProps<{}, T.OperationalWarehouseProps>(({ entity }) => {
    return {
      initialValues: {
        ...entity,
        histories: (entity.histories || []).map(history => {
          const getState = (field: string) => {
            let value;

            try {
              value = JSON.parse(history[field]);
            } catch {
              return undefined;
            }

            return value;
          };

          return { ...history, before: getState('before'), after: getState('after') };
        })
      }
    };
  }),
  withHandlers({
    onSubmit:
      ({ putItemNotify, closeItem, handleLoader }) =>
      async ({ id, note }) => {
        handleLoader(true);

        const ok = await putItemNotify(id, note, true);

        handleLoader(false);

        if (ok) {
          closeItem();
        }
      }
  }),
  reduxForm({
    form: 'module-operational-warehouse'
  })
);

export const View: React.SFC<T.Outter & T.OperationalWarehouseFormProps> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    {props.loader && <Loader />}
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Tabs
          value={props.activeTab}
          onChange={value => props.setActiveTab(value)}
          items={[
            {
              value: 'item',
              label: 'Předmět',
              style: { minWidth: 175 },
              content: <OperationalWarehouseFormBasic files={props.entity.files} />
            },
            {
              value: 'histories',
              label: 'Historie',
              style: { minWidth: 175 },
              content: <Histories />
            }
          ]}
        />
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zpět" style={{ margin: '16px 0 16px 16px' }} onClick={props.closeItem} />
      </Card>
    </form>
  </div>
);

export const OperationalWarehouseForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/operationalWarehouse/operationalWarehouseForm.tsx